import { useCallback, useState } from 'react'
import { DecisionModalProps } from '@npco/zeller-design-system'

import {
  SectionWrapper,
  StyledDecisionModal,
} from '../TransferModal/TransferModal.styled'
import { TransferConfirmationHeader } from './TransferConfirmationHeader/TransferConfirmationHeader'

export interface TransferConfirmationModalProps {
  decisionModalProps: DecisionModalProps
  paddingTop: string
  modalMinHeight: number
  children: React.ReactNode
}

export const TransferConfirmationModal = ({
  decisionModalProps,
  paddingTop,
  modalMinHeight,
  children,
}: TransferConfirmationModalProps) => {
  const [isShowingDetails, setIsShowingDetails] = useState(false)

  const toggleShowDetails = useCallback(() => {
    setIsShowingDetails((prev) => !prev)
  }, [])

  return (
    <StyledDecisionModal
      {...decisionModalProps}
      className="animated-content"
      overlayClassName="animated-overlay"
      bodyClassName="transfer-modal-body"
      contentStyle={{
        minHeight: modalMinHeight,
      }}
      $overflow={isShowingDetails ? undefined : 'visible'}
    >
      <>
        <TransferConfirmationHeader
          paddingTop={paddingTop}
          modalMinHeight={modalMinHeight}
          isShowingDetails={isShowingDetails}
          toggleShowDetails={toggleShowDetails}
        />
        {isShowingDetails && children}
      </>
    </StyledDecisionModal>
  )
}

TransferConfirmationModal.DecisionModal = StyledDecisionModal
TransferConfirmationModal.SectionWrapper = SectionWrapper
